import { ActorProfilePreviewFragmentFragment } from '@lopo-tech/lopo-api'
import React, { FunctionComponent, useEffect } from 'react'
import { useInView } from 'react-intersection-observer'
import { UrlUtils } from 'src/utils/url/url'
import ProfilesListItemSegment from '../item_segment/layouts/profiles_list/profiles_list'

interface IProps {
  profile: ActorProfilePreviewFragmentFragment;
  onVisibleChange?: (id: string, inView: boolean) => void;
}
const ProfileListItem: FunctionComponent<IProps> = ({ profile, onVisibleChange }: IProps) => {
  const { id, slug, shapeSponsorshipLevel, avatar, name, description, __typename, canShow } = profile

  const { ref, inView } = useInView({
    threshold: 0,
    rootMargin: '0px 0px -64px 0px'
  })

  useEffect(() => {
    onVisibleChange?.(id, inView)
  }, [id, inView, onVisibleChange])

  return (
    <div ref={ref}>
      <ProfilesListItemSegment
        key={slug}
        shapeSponsorshipLevel={shapeSponsorshipLevel}
        avatar={avatar}
        label={name}
        description={description}
        navigation={{ url: UrlUtils.getProfileFrontendPath(slug, __typename), featureBlocked: !canShow.value }}
        action={{ follow: { actorProfile: profile } }}
      />
    </div>
  )
}

export default ProfileListItem
